import * as settings from '@/settings';
import { IFsFileData, IFsFileType } from '@r3f-component-data-structure';
import { filestore, Filestore } from '../store';


export class FsBaseFile implements IFsFileData {
    fs: Filestore
    id: string
    type: IFsFileType = IFsFileType.Unknown
    /** `<FILESTORE_URL>/proj-<projectId>/<fileId>`; subclasses append their own object keys to it. */
    baseUrl: string
    name = ''

    constructor(fileId: string, projectId: string, name: string) {
        this.fs = filestore
        this.id = fileId
        this.name = name
        this.baseUrl = `${settings.FILESTORE_URL}/proj-${projectId}/${this.id}`
    }

    async getFilesForBundler(): Promise<{ path: string, bin?: Uint8Array }[]> {
        return Promise.resolve([])
    }
}
